var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-7 min-w-12 min-h-7 relative w-12 duration-200 rounded-full",class:{'bg-gray': !_vm.value},style:(_vm.value ? {background: _vm.themeColorHEX} : {})},[_c('div',{staticClass:"bottom-px2 top-px2 absolute w-6 h-6 duration-200 bg-white rounded-full",class:{'right-px2': _vm.value, 'right-[1.375rem]': !_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }